import { render, staticRenderFns } from "./organization-settings-tab.vue?vue&type=template&id=4b8aadb2"
import script from "./organization-settings-tab.ts?vue&type=script&lang=js&external"
export * from "./organization-settings-tab.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports